import { useQuery } from '@tanstack/react-query';
import { fetchDmCompliance, type ComplianceData } from '../services/dmCompliance';

export function useDmCompliance(patientId: string | undefined, dmId: number | null | undefined) {
    const { data, error, isLoading } = useQuery<ComplianceData | null>({
        queryKey: ['v2/patients', patientId, 'monitoring', 'compliance'],
        queryFn: () => fetchDmCompliance(patientId!),
        enabled: !!patientId && !!dmId,
        staleTime: 5 * 60 * 1000,
        retry: 1
    });

    return { data: data ?? null, isLoading, error };
}
